import {HtmlUtils, EnvelopBody} from "inet-core";
import {DateFormatter} from "../DateFormatter";
import {OpenGraphData} from "../open-graph";

declare let iNet: any;

export class MessageChat {
    message: EnvelopBody;
    isSent: boolean = false;
    attachments: any[] = [];

    displayText: string;
    shortTime: string;
    longTime: string;
    date: Date;
    _openGraph?: OpenGraphData;

    constructor(message: EnvelopBody) {
        const formatter = new DateFormatter(message.sent || new Date());
        this.message = message;
        this.isSent = this.message.sender === iNet.username;
        this.attachments = MessageChat.parseAttachments(message);
        this.displayText = HtmlUtils.formatHtmlDisplay(message.message.alert || message.message.content);
        this.shortTime = formatter.formatTime();
        this.longTime = formatter.formatFullYear();
        this.date = formatter.date;
    }

    static parseAttachments(data: EnvelopBody | any) {
        // uuid://5d021cb39278c2c3666081a0
        var attachments = [];
        for (const k in data.message) {
            if (k.startsWith('uuid://')) {
                var name = data.message[k];
                var canViewInline = /(png|jpg|jpeg|pdf)$/i.test(name);
                var fileIsImage = /(png|jpg|jpeg|gif)$/i.test(name);
                var url = iNet.getPUrl(canViewInline ? 'message/binaryinline' : 'message/binary') +
                    `?uuid=${data.uuid}&uploadID=${k}`;
                attachments.push({
                    url: url,
                    id: k,
                    name: name,
                    image: fileIsImage,
                    canViewInline: canViewInline
                });
            }
        }
        return attachments;
    }
}
